import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import { useEffect } from "react";
import { useScrollLock } from "../../../hooks/useScrollLock";
import { showModal } from "../../../features/modal/modalSlice";
import { handleActiveSelect } from "../../../features/layout/layoutSlice";
import { showRegisterModal } from "../../../features/register/registerSlice";
import PDFViewer from "../../registerSections/PDFViewer";


const Container = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 26;

  .modal {
    width: auto;
    height: auto;
    color: ${({ theme }) => theme.mainTextColor};
    background-color: ${({ theme }) => theme.mainBgColor};
    padding: 30px;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    justify-content: space-between;


    .content {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
        
    }
  }
`;

const UyelikSozlesmesiModal = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  
  const { modalLocation } = useSelector((state) => state.modal);
  const { lockScroll, unlockScroll } = useScrollLock();

  //! bu modal açıldığnda ekran ı lock lamak için
  useEffect(() => {
    lockScroll();

    return () => {
      unlockScroll();
    };
  }, [lockScroll, unlockScroll]);

  //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
//   useEffect(() => {
//     if (location.pathname !== modalLocation) {
//       dispatch(showRegisterModal(null));
//     }
//   }, [dispatch, location.pathname, modalLocation]);


  return (
    <Container onClick={() => dispatch(showRegisterModal(null))}>
      <div
        className="modal"
        onClick={(e) => {
          e.stopPropagation();
          dispatch(handleActiveSelect(null));
        }}
      >
        <div className="content">
            <PDFViewer fileUrl={"https://drive.google.com/file/d/1fKMnAw51pB5kEICFZjfM-F7dic6mVzt1/preview"} />
        </div>
      </div>
    </Container>
  );
};

export default UyelikSozlesmesiModal;
